import { FlexRow } from '@epam/promo';

import { FormHeaderInfo } from './FormHeaderInfo';
import { FormHeaderActions } from './FormHeaderActions';
import { FormHeaderProps } from './FormHeader.model';
import css from './FormHeader.module.scss';

export const FormHeader = ({
  draft,
  handleSaveAsDraft,
  handleSaveForApprove,
  handleReject,
  handleApprove,
  handleSendToRework,
  handleDelete,
}: FormHeaderProps) => (
  <FlexRow cx={css.form} padding="24" vPadding="12">
    <FormHeaderInfo draft={draft} />
    <FormHeaderActions
      handleApprove={handleApprove}
      handleDelete={handleDelete}
      handleReject={handleReject}
      handleSaveAsDraft={handleSaveAsDraft}
      handleSaveForApprove={handleSaveForApprove}
      handleSendToRework={handleSendToRework}
      status={draft.status}
    />
  </FlexRow>
);
